import { makeActionCreator } from '../../utils/actionsUtils';
import { SEARCH_INPUT, SEARCH_CLEAR } from './constants';

export const searchInput = makeActionCreator(SEARCH_INPUT, 'input');
export const searchClear = makeActionCreator(SEARCH_CLEAR);



// WEBPACK FOOTER //
// ./src/services/search/actions.js